import { render, staticRenderFns } from "./ExtraPopover.vue?vue&type=template&id=dc44abae&scoped=true"
import script from "./ExtraPopover.vue?vue&type=script&lang=js"
export * from "./ExtraPopover.vue?vue&type=script&lang=js"
import style0 from "./ExtraPopover.vue?vue&type=style&index=0&id=dc44abae&prod&lang=scss"
import style1 from "./ExtraPopover.vue?vue&type=style&index=1&id=dc44abae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc44abae",
  null
  
)

export default component.exports